import { useMemo } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Select } from '@factorialco/f0-react'
import {
  WorkplacesLocationsSelectorDocument,
  WorkplacesLocationsSelectorQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface Workplace {
  id: string
  name: string
}

interface WorkplaceSelectorProps {
  value?: Workplace | null
  onSelect: (workplace: Workplace | null) => void
  label?: string
  emptyLabel?: string
  mandatory?: boolean
  disabled?: boolean
  error?: boolean
}

export const WorkplaceSelector = ({
  value,
  onSelect,
  label,
  emptyLabel,
  mandatory = false,
  disabled = false,
  error = false,
}: WorkplaceSelectorProps) => {
  const { data: workplacesData } = useQuery<
    WorkplacesLocationsSelectorQuery,
    Record<string, never>
  >(WorkplacesLocationsSelectorDocument)

  const options = useMemo(
    () =>
      (workplacesData?.locations?.locationsConnection?.nodes || []).map(
        (
          node: WorkplacesLocationsSelectorQuery['locations']['locationsConnection']['nodes'][0]
        ) => ({
          label: node?.name || '',
          value: String(node?.id || ''),
          avatar: {
            type: 'team' as const,
            name: node?.name || '',
            src: '',
          },
        })
      ),
    [workplacesData]
  )

  const handleChange = (workplaceId: string) => {
    const workplace = workplacesData?.locations?.locationsConnection?.nodes?.find(
      (node: WorkplacesLocationsSelectorQuery['locations']['locationsConnection']['nodes'][0]) =>
        String(node?.id) === workplaceId
    )
    onSelect(
      workplace
        ? {
            id: String(workplace.id),
            name: workplace.name || '',
          }
        : null
    )
  }

  return (
    <Box gap="s8">
      <F0Select
        label={label}
        value={value?.id}
        onChange={handleChange}
        options={options}
        placeholder={emptyLabel}
        size="md"
        searchable
        showSearchBox
        disabled={disabled}
        error={error}
        required={mandatory}
      />
    </Box>
  )
}
